import { getKerioSpamSettings, setKerioSpamSettings, } from "@apps/client-sdk";
import { el } from "../dom.js";
import { isKerioAuthError, renderKerioPasswordUpdate, } from "./kerioPasswordUpdate.js";
export function renderKerioSpamSection(options) {
    const section = el("section", "card");
    section.append(el("h2", undefined, "Spam Filter"));
    const status = el("p", "muted", "Loading…");
    section.append(status);
    const form = el("div", "prefs-form mt");
    form.hidden = true;
    const enabledLabel = el("label", "checkbox-row");
    const enabledInput = el("input");
    enabledInput.type = "checkbox";
    enabledLabel.append(enabledInput, document.createTextNode(" Move spam to Junk folder"));
    form.append(enabledLabel);
    const contactsLabel = el("label", "checkbox-row");
    const contactsInput = el("input");
    contactsInput.type = "checkbox";
    contactsLabel.append(contactsInput, document.createTextNode(" Trust senders from Contacts"));
    form.append(contactsLabel);
    form.append(el("h3", "mt", "Trusted senders"));
    const listEl = el("ul", "pref-list");
    form.append(listEl);
    const addRow = el("div", "inline-add mt");
    const addInput = el("input", "input");
    addInput.type = "email";
    addInput.placeholder = "user@example.com";
    const addBtn = el("button", "btn btn-secondary btn-sm", "Add");
    addBtn.type = "button";
    addRow.append(addInput, addBtn);
    form.append(addRow);
    const saveBtn = el("button", "btn btn-primary mt", "Save");
    saveBtn.type = "button";
    form.append(saveBtn);
    section.append(form);
    let settings = {
        isEnabled: true,
        whiteListContacts: false,
        autoupdateWhiteList: false,
        whiteList: [],
    };
    const paintList = () => {
        listEl.replaceChildren();
        if (settings.whiteList.length === 0) {
            listEl.append(el("li", "muted", "No trusted senders."));
            return;
        }
        for (const addr of settings.whiteList) {
            const li = el("li");
            li.append(document.createTextNode(addr + " "));
            const remove = el("button", "btn btn-secondary btn-sm", "Remove");
            remove.type = "button";
            remove.addEventListener("click", () => {
                settings = {
                    ...settings,
                    whiteList: settings.whiteList.filter((x) => x !== addr),
                };
                paintList();
            });
            li.append(remove);
            listEl.append(li);
        }
    };
    const paint = () => {
        enabledInput.checked = settings.isEnabled;
        contactsInput.checked = settings.whiteListContacts;
        paintList();
    };
    const showStatus = (msg, kind) => {
        status.textContent = msg;
        status.className = kind === "error" ? "error" : kind === "success" ? "success" : "muted";
        status.hidden = false;
        options.showStatus?.(msg, kind);
    };
    addBtn.addEventListener("click", () => {
        const value = addInput.value.trim().toLowerCase();
        if (!value)
            return;
        if (!settings.whiteList.includes(value)) {
            settings = { ...settings, whiteList: [...settings.whiteList, value] };
            paintList();
        }
        addInput.value = "";
    });
    saveBtn.addEventListener("click", () => {
        void (async () => {
            settings = {
                isEnabled: enabledInput.checked,
                whiteListContacts: contactsInput.checked,
                // Preserve server value — this only applies in Kerio webmail/KOFF, not IMAP.
                autoupdateWhiteList: settings.autoupdateWhiteList,
                whiteList: settings.whiteList,
            };
            showStatus("Saving…", "muted");
            try {
                settings = await setKerioSpamSettings(options.storage, settings);
                paint();
                showStatus("Spam settings saved.", "success");
            }
            catch (error) {
                showStatus(error instanceof Error ? error.message : "Save failed", "error");
            }
        })();
    });
    const load = async () => {
        try {
            settings = await getKerioSpamSettings(options.storage);
            form.hidden = false;
            paint();
            status.hidden = true;
            const existing = section.querySelector(".kerio-password-update");
            existing?.remove();
        }
        catch (error) {
            const message = error instanceof Error ? error.message : "Failed to load spam settings";
            showStatus(message, "error");
            if (isKerioAuthError(message) && !section.querySelector(".kerio-password-update")) {
                section.append(renderKerioPasswordUpdate(options.storage, () => {
                    void load();
                }));
            }
        }
    };
    void load();
    return section;
}
